// extracted by mini-css-extract-plugin
export default {"mv":"Contact_mv__5GwLh","title":"Contact_title__uIUug"};